import { useSelector } from 'react-redux';
import { safeSessionStorage, safeStringify } from '../helpers/ssr-helper';

export const useAppName = () => {
  return useSelector((state) => state?.applicationState?.nombre || '');
};

export const getAppNameFromStore = (state) => state?.applicationState?.nombre || '';

export const useTemplateDataFromStorage = () => {
  try {
    const storedData = safeSessionStorage.getItem('templateData');
    if (storedData) {
      return JSON.parse(storedData);
    }
    return null;
  } catch (error) {
    console.warn('Error reading template data from sessionStorage:', error);
    return null;
  }
};

export const useMainMenuFromStorage = () => {
  try {
    const storedData = safeSessionStorage.getItem('templateData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const mainMenu = parsedData?.templateData?.mainMenu;
      return mainMenu?.filter((item) => item.activo === true) || [];
    }
    return [];
  } catch (error) {
    console.warn('Error reading mainMenu from sessionStorage:', error);
    return [];
  }
};

export const saveTemplateDataToStorage = (templateData, applicationId) => {
  try {
    const dataToSave = {
      ...templateData,
      timestamp: Date.now(),
      applicationId: applicationId,
    };

    const safeJsonString = safeStringify(dataToSave);
    return safeSessionStorage.setItem('templateData', safeJsonString);
  } catch (error) {
    console.warn('Error saving template data to sessionStorage:', error);
    return false;
  }
};

export const clearTemplateDataFromStorage = () => {
  try {
    return safeSessionStorage.removeItem('templateData');
  } catch (error) {
    console.warn('Error clearing template data from sessionStorage:', error);
    return false;
  }
};
